import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=feff1060&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('feff1060')) {
      api.createRecord('feff1060', component.options)
    } else {
      api.reload('feff1060', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=feff1060&", function () {
      api.rerender('feff1060', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2cC5CrA7NNyXF/JS/pricehelp.vue"
export default component.exports